module.exports = __webpack_public_path__ + "assets/loyalty-promotion-launching.eda3a150.svg";